import { render, staticRenderFns } from "./AtendimentoLegadoForm.vue?vue&type=template&id=32db2044"
import script from "./AtendimentoLegadoForm.vue?vue&type=script&lang=js"
export * from "./AtendimentoLegadoForm.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoLegadoForm.vue?vue&type=style&index=0&id=32db2044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports